import React from "react";
import { cn } from "../../../common/u1/cn";

/* The dark card at the top of the edit rail. */
export const ProfileCompletionCard = ({
  completed = 0,
  total = 0,
  className = "",
}) => {
  const percent = total ? Math.round((completed / total) * 100) : 0;

  return (
    <section
      /* A bare <section> is not a landmark until it has a name, so the heading
         below names it. */
      aria-labelledby="u1-completion-heading"
      className={cn(
        "rounded-[14px] bg-[image:var(--plan-grad)] px-[18px] py-4",
        className
      )}
    >
      <h2
        id="u1-completion-heading"
        className="m-0 text-[10.5px] font-bold uppercase tracking-[0.13em] text-[var(--plan-micro)] font-sans"
      >
        Profile completion
      </h2>

      <p className="mb-2.5 mt-1.5 text-[28px] font-bold leading-none text-white font-sans">
        {percent}%
      </p>

      <div
        aria-hidden="true"
        className="h-[5px] w-full overflow-hidden rounded-full bg-[var(--plan-rule)]"
      >
        <span
          className="block h-full rounded-full bg-[var(--orange)] transition-[width] duration-300"
          /* A percentage width is the one value that cannot come from a
             Tailwind class — it is data, not design. */
          style={{ width: `${percent}%` }}
        />
      </div>

      <p className="mt-2.5 mb-0 text-[11.5px] text-[var(--plan-body)] font-sans">
        {completed} of {total} sections complete
      </p>
    </section>
  );
};

export default ProfileCompletionCard;
